import { z } from 'zod'

export const NotificationZod = z.object({
  type: z.string(),
  userId: z.string(),
  message: z.object({
    android: z
      .object({
        collapseKey: z.string().optional(),
        priority: z.enum(['high', 'normal']).optional().default('normal'),
        ttl: z.number().optional(), // milliseconds
        // https://firebase.google.com/docs/reference/admin/dotnet/class/firebase-admin/messaging/android-notification
        notification: z
          .object({
            sticky: z.boolean().optional(),
            titleLocKey: z.string().optional(),
            titleLocArgs: z.array(z.string()).optional(),
            bodyLocKey: z.string().optional(),
            bodyLocArgs: z.array(z.string()).optional(),
            priority: z.enum(['min', 'low', 'default', 'high', 'max']).optional(),
            tag: z.string().optional(),
            channelId: z.string().optional(),
            imageUrl: z.string().optional(),
          })
          .optional(),
      })
      .optional(),
    apns: z
      .object({
        payload: z
          .object({
            // https://developer.apple.com/library/archive/documentation/NetworkingInternet/Conceptual/RemoteNotificationsPG/PayloadKeyReference.html
            aps: z.object({
              category: z.string().optional(),
              threadId: z.string().optional(),
              alert: z
                .object({
                  titleLocKey: z.string().optional(),
                  titleLocArgs: z.array(z.string()).optional(),
                  subtitleLocKey: z.string().optional(),
                  subtitleLocArgs: z.array(z.string()).optional(),
                  locKey: z.string().optional(),
                  locArgs: z.array(z.string()).optional(),
                })
                .optional(),
            }),
          })
          .optional(),
      })
      .optional(),
    data: z.record(z.string(), z.string()).optional(),
  }),
  result: z
    .object({
      responses: z
        .object({
          success: z.boolean(),
          messageId: z.string().optional(),
        })
        .array(),
      successCount: z.number(),
      failureCount: z.number(),
    })
    .optional(),
})
